import { connect } from 'react-redux'
import View from './index'
import {stdAction, ACTIONS} from '../../actions/Actions'

const mapStateToProps = (state, ownProps) => {
    return {
	groups: state.groups,
	credits: state.credits,
	current_user: state.users.current,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {

    return {
	getCredits: () => dispatch(stdAction(ACTIONS.credits.index)),
	getGroups: () => dispatch(stdAction(ACTIONS.groups.index)),
	createGroup: ({values}) => dispatch(stdAction(((values.id === undefined || values.id===null) ? ACTIONS.groups.create : ACTIONS.groups.update(values.id)), values, () => dispatch(stdAction(ACTIONS.groups.index)))),
	deleteGroup: (id) => dispatch(stdAction(ACTIONS.groups.delete(id), {id: id}, () => dispatch(stdAction(ACTIONS.groups.index)))),
	deleteUser: (id) => dispatch(stdAction(ACTIONS.users.delete(id), {id: id}, () => dispatch(stdAction(ACTIONS.groups.index)))),
	addUser: ({values, props}) =>  dispatch(stdAction(((values.id === undefined || values.id===null) ? ACTIONS.users.create : ACTIONS.users.update(values.id)), {...{group_id: props.group_id}, ...values }, () => dispatch(stdAction(ACTIONS.groups.index))))	
    }
}

const Container = connect(
    mapStateToProps,
    mapDispatchToProps
)(View)

export default Container
